import React from 'react';
import OrderForm from '../OrderForm'
import * as Yup from "yup";
import { withStyles, Grid, Dialog, Paper } from '@material-ui/core';
import ExternalInfoTable from '../../../sc-externalTable';
import { hasPermission } from '../../../sc-utilities';
import { statuses, types } from '../../../sc-utilities/OrderUtilities';
import QRCode from 'qrcode.react';
import '../../../sc-product/qrCode.scss';
import AppLogoLoading from '../../../sc-logo';

const styles = theme => ({
    root: {
        width: '100%',
        height: 'auto',
        padding: 0,
        margin: 0
    },
    inputs: {
        width: '100%'
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden"
    },
    logo: {
        width: '250px',
        margin: '10px'
    },
    qrCode: {
        float: 'left',
        marginRight: "0.5%",
    },
});

const OrderDetails = props => {
    const { classes, activeCustomer, onUnpairedExternal, onUnpairedBulkExternal, activeExternalServiceAvailable, order, reportInformation, filePatterns, loading, translations, permissions, groups } = props;


    let initialValues = {
        Name: order ? order.Name : '',
        Description: order ? order.Description : '',
        ReportDataID: order && order.ReportDataID ? order.ReportDataID : reportInformation[0] && reportInformation[0].value ? reportInformation[0].value : '',
        FilePatternID: order && order?.FilePatternID?.toString() ? order?.FilePatternID?.toString() : filePatterns[0] && filePatterns[0].value ? filePatterns[0]?.value?.toString() : '',
        ProjectID: order?.ProjectID ?? '',
        Status: order ? order.Status : '',
        Type: order && order.Type ? order.Type : '',
        ErasureReportSignature: order && order.ErasureReportSignature ? order.ErasureReportSignature : false,
        DefaultLanguage: order && order.DefaultLanguage ? order.DefaultLanguage : 'en',
        GroupID: order?.GroupID ?? 'n/a'
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Description: Yup.string().notRequired("Not required"),
        },
        FormTitle: translations['edit_order'] || "Edit order",
        ButtonSubmit: hasPermission(permissions, "order_save") ? {
            Title: translations["save"] || "SAVE"
        } : null,

    };

    const handleSubmit = async data => {
        if (data['GroupID'] === 'n/a') {
            data['GroupID'] = null;
        }
        await props.onEditOrder({
            ...data, ReportDataID: data['ReportDataID'] !== 'reportInfo_none' ? data['ReportDataID'] : null,
            FilePatternID: data['FilePatternID'] !== 'filePattern_none' ? data['FilePatternID'] : null,
            Type: data['Type'],
            ProjectID: data['ProjectID'] === '' ? null : data['ProjectID'],
            OrderID: order.OrderID, ActiveCustomerID: activeCustomer
        });
    };

    return (
        <>
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={!loading}
                PaperProps={{
                    classes: {
                        root: classes.paper
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            <div className="tooltip">
                <QRCode
                    size={50}
                    className={classes.qrCode}
                    value={`<Order>${order.OrderID}</Order>`}
                />
                <span>
                    <QRCode
                        size={200}
                        value={`<Order>${order.OrderID}</Order>`}
                    />
                </span>
            </div>
            <Grid container className={classes.root} spacing={1}>
                <Grid item xs={hasPermission(permissions, 'palette_external_info_view') && activeExternalServiceAvailable ? 6 : 12}>
                    <Paper>
                        <OrderForm
                            formSettings={formSettings}
                            initialValues={initialValues}
                            handleSubmit={handleSubmit}
                            translations={translations}
                            statuses={statuses}
                            types={types}
                            reportInformation={reportInformation}
                            filePatterns={filePatterns}
                            groups={groups}
                        ></OrderForm>
                    </Paper>
                </Grid>
                {hasPermission(permissions, 'palette_external_info_view') && activeExternalServiceAvailable ?
                    <Grid item xs={6}>
                        <ExternalInfoTable onUnpairedExternal={onUnpairedExternal} type={translations['order'] || 'Order'} onUnpairedBulkExternal={onUnpairedBulkExternal} data={order && order.PaletteExternalInfo ? order.PaletteExternalInfo : []} />
                    </Grid>
                    : null}
            </Grid>
        </>
    )
}
export default withStyles(styles, { withTheme: true })(OrderDetails);
